import { TransformedToken } from 'style-dictionary'
import { ColorSwatch } from './ColorSwatch'
import { ExternalLink } from '@dashboard/ui'

interface TokenStudioTokenPreviewProps {
  token: TransformedToken
}

export const TokenStudioTokenPreview = ({ token }: TokenStudioTokenPreviewProps) => {
  if (token.type === 'color') {
    return (
      <div className="flex items-center gap-2">
        <ColorSwatch color={token.value} />
        <span>{token.value}</span>
      </div>
    )
  }

  if (token.type === 'shadow') {
    const hexFromValue = token.value.split(' ').at(-1)

    return (
      <div
        className="-m-2 flex items-center gap-2 rounded-md bg-[rgba(0,0,0,0.025)] p-2"
        style={{ boxShadow: token.value }}
      >
        <ColorSwatch color={hexFromValue} size="sm" />
        <span>{token.value}</span>
      </div>
    )
  }

  if (token.type === 'asset' && token.attributes?.category === 'bg') {
    if (token.value === 'url(":empty")') {
      return <div>–</div>
    }

    return (
      <a
        className="flex h-12 w-20 items-center gap-2 rounded-md bg-cover bg-center bg-no-repeat"
        href={token.value.replace('url(', '').replace(')', '').replaceAll('"', '')}
        target="_blank"
        rel="noopener noreferrer"
        style={{
          backgroundImage: token.value,
        }}
      />
    )
  }

  if (token.type === 'dimension' && token.attributes?.category === 'border-width') {
    return (
      <div className="flex items-center gap-2 ">
        <div className="size-10 border bg-[rgba(0,0,0,0.025)]" style={{ borderWidth: token.value }} />
        <span>{token.value}</span>
      </div>
    )
  }

  if (token.type === 'dimension' && token.attributes?.category === 'border-radius') {
    return (
      <div className="flex items-center gap-2">
        <div className="size-10 border bg-[rgba(0,0,0,0.025)]" style={{ borderRadius: token.value }} />
        <span>{token.value}</span>
      </div>
    )
  }

  if (token.type === 'fontFamily') {
    return (
      <div className="flex items-center gap-2">
        <div className="font-medium text-text-secondary">{token.original.value}</div>
        {!token.urls && (
          <a
            href={`https://fonts.google.com/specimen/${token.original.value}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            <ExternalLink />
          </a>
        )}
      </div>
    )
  }

  return <div>–</div>
}
